(() => {
  const initialized = window.VenaClinicalInitialized || new WeakSet();
  window.VenaClinicalInitialized = initialized;

  function init(section) {
    if (initialized.has(section)) return;
    initialized.add(section);

    const modal = section.querySelector('[data-vena-methodology-modal]');
    const opener = section.querySelector('[data-vena-methodology-open]');
    if (!modal || !opener) return;

    const dialog = modal.querySelector('.vena-clinical__modal-dialog');
    const closeButtons = modal.querySelectorAll('[data-vena-methodology-close]');
    let lastFocused = null;

    function closeModal() {
      if (modal.hidden) return;
      modal.classList.remove('is-open');
      document.body.classList.remove('vena-clinical-modal-open');
      window.setTimeout(() => {
        modal.hidden = true;
        if (lastFocused) lastFocused.focus();
      }, 180);
    }

    function openModal() {
      lastFocused = document.activeElement;
      modal.hidden = false;
      requestAnimationFrame(() => modal.classList.add('is-open'));
      document.body.classList.add('vena-clinical-modal-open');
      window.setTimeout(() => dialog.focus(), 40);
    }

    opener.addEventListener('click', openModal);
    closeButtons.forEach((button) => button.addEventListener('click', closeModal));
    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeModal();
    });
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-vena-clinical]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();